module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc3-56506d58a3912fd0f46d069fcfbaf7e1.jpg";